import { render, staticRenderFns } from "./FoodRegistrationFormModal.vue?vue&type=template&id=fadaad96&scoped=true&lang=html"
import script from "./FoodRegistrationFormModal.vue?vue&type=script&lang=js"
export * from "./FoodRegistrationFormModal.vue?vue&type=script&lang=js"
import style0 from "./FoodRegistrationFormModal.vue?vue&type=style&index=0&id=fadaad96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadaad96",
  null
  
)

export default component.exports